import { defineMessages } from "react-intl";

const messages = defineMessages({
    moderation: {
        id: "menu.moderation",
    },
    registration: {
        id: "menu.registration",
    },
    login: {
        id: "menu.login",
    },
    logout: {
        id: "menu.logout",
    },
    account: {
        id: "menu.account",
    },
    help: {
        id: "help.title",
    },
    username: {
        id: "account.username",
    },
    translate: {
        id: "menu.translate",
    },
    aboutUs: {
        id: "menu.aboutUs",
    },
    teachingSettings: {
        id: "teachingSettings.title",
    },
});

export default messages;
